import { Box, Grid, Tab, Tabs, Typography } from '@mui/material'
import { useState } from 'react'

interface BaseViewProps {
    title: string
    titleExtraContent?: JSX.Element
    subviews: JSX.Element[]
    tabNames?: string[]
}

const BaseView = (props: BaseViewProps) => {
    const { title, titleExtraContent, subviews, tabNames } = props

    const [tabSection, setTabSection] = useState(0)

    const renderSubview = () => {
        if (!tabNames) {
            return subviews[0]
        }
        return subviews[tabSection]
    }

    return (
        <Grid container direction="column" style={{ padding: '40px', overflowX: 'auto' }}>
            <Grid item>
                <Box style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <Typography variant="h3">{title}</Typography>
                    {titleExtraContent}
                </Box>
            </Grid>
            <Grid item>
                <Box sx={{ marginTop: '30px', borderBottom: 1, borderColor: 'divider' }}>
                    {tabNames && (
                        <Tabs
                            value={tabSection}
                            onChange={(_event, value) => setTabSection(value)}
                            aria-label="basic tabs example"
                        >
                            {tabNames.map((tabName) => (
                                <Tab label={tabName} key={tabName} />
                            ))}
                        </Tabs>
                    )}
                </Box>
            </Grid>
            <Grid item>
                <Box style={{ marginTop: '30px' }}>{renderSubview()}</Box>
            </Grid>
        </Grid>
    )
}

export default BaseView
